import { createElement } from 'react';
import { getComputedProps } from 'selectors/learn/content';

const withComputedProps = Component => {
  const WrappedComponent = props =>
    createElement(Component, {
      ...props,
      ...getComputedProps(props),
    });
  WrappedComponent.displayName = `withComputedProps(${Component.name})`;
  return WrappedComponent;
};

export default withComputedProps;
